module.exports = __webpack_public_path__ + "static/media/swimming_pool.d11232b1.svg";